<template>
  <div>
    <!-- Page title -->
    <div class="w-100 d-flex flex-column flex-md-row justify-content-between between mb-2">
      <h1 class="text-secondary">
        Dispositivos
      </h1>

      <div>
        <b-breadcrumb>
          <b-breadcrumb-item to="devices">
            <feather-icon
              icon="HardDriveIcon"
              size="16"
            />
            <span style="padding-left: 4px"> Dispositivos </span>
          </b-breadcrumb-item>
          <b-breadcrumb-item active>
            Listado dispositivos
          </b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>

    <!-- Table Container Card -->
    <b-card no-body>
      <b-overlay
        :show="loading"
        rounded="sm"
        :variant="$store.state.appConfig.layout.skin === 'dark' ? 'dark' : 'light'"
      >
        <!-- Table Top -->
        <b-row class="m-2">
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Items</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1"
            />
            <b-button
              variant="primary"
              class="d-inline-block ml-auto ml-md-0"
              @click="dialog = true"
            >
              Nuevo
            </b-button>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Buscar..."
              />
              <b-button
                variant="outline-primary"
                class="ml-2"
                @click="dialogExport = true"
              >
                Exportar
              </b-button>
            </div>
          </b-col>
        </b-row>

        <!-- Modal edit device -->
        <b-modal
          v-model="dialog"
          size="xl"
          title="Editar dispositivo"
          hide-footer
          no-close-on-backdrop
          no-close-on-esc
        >
          <add-edit
            v-if="dialog"
            :item.sync="editedItem"
            :device="editedItem"
            :sites="sites"
            :models="models"
            :cloud-devices="cloudDevices"
            :ums="ums"
            :loading.sync="loading"
            @close="close"
            @save="save"
          />
        </b-modal>

        <!-- Modal remove device -->
        <b-modal
          v-model="dialogDelete"
          title="Eliminar dispositivo"
          hide-footer
        >
          <delete-data
            :id-item="editedItem.id"
            :loading.sync="loading"
            @close="close"
            @delete="remove"
          />
        </b-modal>

        <!-- Modal export -->
        <b-modal
          v-model="dialogExport"
          title="Exportar datos"
          hide-footer
        >
          <export-data
            :loading.sync="loading"
            @close="close"
            @export="exportData"
          />
        </b-modal>

        <!-- DEVICES LIST TABLE -->
        <b-table
          ref="refDataTable"
          :items="fetchData"
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No hay datos disponibles."
          :sort-by.sync="sortBy"
          :sort-desc.sync="isSortDirDesc"
          :loading="loading"
          loading-text="Cargando..."
          responsive
          class="position-relative"
        >
          <!-- Column: Name -->
          <template #cell(name)="data">
            <b-link
              class="font-weight-bold"
              @click="editItem(data.item)"
            >
              {{ data.value }}
            </b-link>
          </template>

          <!-- Column: Cloud ID -->
          <template #cell(cloud_id)="data">
            <div class="text-nowrap">
              <span :id="`device-row-${data.item.id}-cloud-id`">
                {{ truncatedCloudId(data.item.cloud_id) }}
              </span>
              <b-tooltip
                :title="data.item.cloud_id"
                class="cursor-pointer"
                :target="`device-row-${data.item.id}-cloud-id`"
              />
            </div>
          </template>

          <!-- Column: Lora -->
          <template #cell(lora)="data">
            <div class="d-flex align-items-center justify-content-center">
              <b-form-checkbox
                :id="`device-row-${data.item.id}-enabled-lora`"
                :checked="data.item.lora"
                disabled
                class="m-0"
              />
              <b-tooltip
                title="Habilitado"
                class="cursor-pointer"
                :target="`device-row-${data.item.id}-enabled-lora`"
              />
            </div>
          </template>

          <!-- Column: Enabled -->
          <template #cell(enabled)="data">
            <div class="d-flex align-items-center justify-content-center">
              <b-form-checkbox
                :id="`device-row-${data.item.id}-enabled-checkbox`"
                :checked="data.item.enabled"
                disabled
                class="m-0"
              />
              <b-tooltip
                title="Habilitado"
                class="cursor-pointer"
                :target="`device-row-${data.item.id}-enabled-checkbox`"
              />
            </div>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <!-- edit device -->
              <feather-icon
                :id="`device-row-${data.item.id}-edit-icon`"
                icon="EditIcon"
                class="cursor-pointer mr-1"
                size="16"
                @click="editItem(data.item)"
              />
              <b-tooltip
                title="Editar"
                class="cursor-pointer"
                :target="`device-row-${data.item.id}-edit-icon`"
              />

              <!-- delete device -->
              <feather-icon
                :id="`device-row-${data.item.id}-trash-icon`"
                icon="TrashIcon"
                class="cursor-pointer"
                size="16"
                @click="deleteItem(data.item)"
              />
              <b-tooltip
                title="Eliminar"
                class="cursor-pointer"
                :target="`device-row-${data.item.id}-trash-icon`"
              />
            </div>
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">
                Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de
                {{ dataMeta.of }} items
              </span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalData"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >

                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>

                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>

        <template #overlay>
          <!-- Show loading spinner if loading -->
          <loading-logo
            v-if="loading"
            class="mt-4 mb-4"
          />
        </template>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BLink,
  BPagination,
  BTooltip,
  BFormCheckbox,
  BOverlay,
  BBreadcrumb,
  BBreadcrumbItem,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import DeleteData from '@/views/utils/DeleteData.vue'
import ExportData from '@/views/utils/ExportData.vue'
import exportFromJSON from 'export-from-json'
import modelStoreModule from '@/views/model_devices/modelDeviceStoreModule'
import modelAllFetchData from '@/views/model_devices/allFetchData'
import siteStoreModule from '@/views/organizations/orgStoreModule'
import siteAllFetchData from '@/views/organizations/allFetchData'
import umStoreModule from '@/views/unit_measurement/umDeviceStoreModule'
import umAllFetchData from '@/views/unit_measurement/allFetchData'
import allFetchData from './allFetchData'
import deviceStoreModule from './deviceStoreModule'
import AddEdit from './AddEdit.vue'
import LoadingLogo from '../miscellaneous/LoadingLogo.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BLink,
    BPagination,
    BTooltip,
    BFormCheckbox,
    BOverlay,
    BBreadcrumb,
    BBreadcrumbItem,
    vSelect,
    DeleteData,
    ExportData,
    LoadingLogo,
    AddEdit,
  },
  setup() {
    // devices
    const DEVICE_APP_STORE_MODULE_NAME = 'devices'

    // Register module
    if (!store.hasModule(DEVICE_APP_STORE_MODULE_NAME)) {
      store.registerModule(DEVICE_APP_STORE_MODULE_NAME, deviceStoreModule)
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(DEVICE_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(DEVICE_APP_STORE_MODULE_NAME)
      }
    })

    // models
    const MODEL_APP_STORE_MODULE_NAME = 'modeldevices'

    // Register module
    if (!store.hasModule(MODEL_APP_STORE_MODULE_NAME)) {
      store.registerModule(MODEL_APP_STORE_MODULE_NAME, modelStoreModule)
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODEL_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(MODEL_APP_STORE_MODULE_NAME)
      }
    })

    // sites
    const SITE_APP_STORE_MODULE_NAME = 'org'

    // Register module
    if (!store.hasModule(SITE_APP_STORE_MODULE_NAME)) {
      store.registerModule(SITE_APP_STORE_MODULE_NAME, siteStoreModule)
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(SITE_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(SITE_APP_STORE_MODULE_NAME)
      }
    })

    // ums
    const UM_APP_STORE_MODULE_NAME = 'umdevices'

    // Register module
    if (!store.hasModule(UM_APP_STORE_MODULE_NAME)) {
      store.registerModule(UM_APP_STORE_MODULE_NAME, umStoreModule)
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(UM_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(UM_APP_STORE_MODULE_NAME)
      }
    })

    const {
      fetchData,
      fetchAdd,
      fetchUpdate,
      fetchDelete,
      fetchExport,
      fetchCloudDevice,
      tableColumns,
      perPage,
      currentPage,
      totalData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataTable,
      loading,
      refetchData,
      cloudDevices,
    } = allFetchData()

    // model
    const {
      fetchExport: fetchDataModel,
      loading: loadingModel,
    } = modelAllFetchData()

    // site
    const {
      fetchExport: fetchDataSite,
      loading: loadingSite,
    } = siteAllFetchData()

    // um
    const {
      fetchExport: fetchDataUm,
      loading: loadingUm,
    } = umAllFetchData()

    return {
      fetchData,
      fetchAdd,
      fetchUpdate,
      fetchDelete,
      fetchExport,
      tableColumns,
      perPage,
      currentPage,
      totalData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataTable,
      loading,
      refetchData,
      fetchCloudDevice,
      cloudDevices,
      fetchDataModel,
      loadingModel,
      fetchDataSite,
      loadingSite,
      fetchDataUm,
      loadingUm,
    }
  },
  data() {
    return {
      dialog: false,
      dialogDelete: false,
      dialogExport: false,
      editedIndex: -1,
      editedItem: {
        id: null,
        name: '',
        cloudId: null,
        siteId: null,
        modelId: null,
        comment: null,
        lora: true,
        enabled: true,
        deviceData: [],
        timeInterval: 5,
        createdAt: '',
        updatedAt: '',
      },
      defaultItem: {
        id: null,
        name: '',
        cloudId: null,
        siteId: null,
        modelId: null,
        comment: '',
        lora: true,
        enabled: true,
        deviceData: [],
        timeInterval: 5,
        createdAt: '',
        updatedAt: '',
      },
      models: [],
      sites: [],
      ums: [],
    }
  },
  watch: {
    dialog(val) {
      // eslint-disable-next-line no-unused-expressions
      val || this.close()
    },
  },
  mounted() {
    this.fetchDataModel('', res => {
      this.models = res
    })
    this.fetchDataSite('', res => {
      this.sites = res
    })
    this.fetchDataUm('', res => {
      this.ums = res
    })
    this.fetchCloudDevice('', () => {})
  },
  methods: {
    updateItem(newItem) {
      this.editedItem = newItem
    },
    add(item) {
      this.fetchAdd(item, () => {
        this.close()
      })
    },
    edit(item) {
      this.fetchUpdate(item, () => {
        this.close()
      })
    },
    remove() {
      this.fetchDelete(this.editedItem.id, () => {
        this.close()
      })
    },
    editItem(item) {
      this.editedItem = JSON.parse(JSON.stringify(item))
      this.dialog = true
    },
    deleteItem(item) {
      this.editedItem = { ...item }
      this.dialogDelete = true
    },
    save(item) {
      if (item.id > 0) {
        this.edit(item)
      } else {
        this.add(item)
      }
    },
    close() {
      this.dialog = false
      this.dialogExport = false
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem }
        this.editedIndex = -1
      })
    },
    exportData() {
      this.fetchExport(this.editedItem, res => {
        try {
          const fileName = 'Listado de Dispositivos'
          const exportType = exportFromJSON.types.xls
          const data = res.map(item => ({
            nombre: item.name,
            modelo: item.model.name,
            comentario: item.comment,
            lora: item.lora ? 'Si' : 'No',
            habilitado: item.enabled ? 'Si' : 'No',
            id_Nube: item.cloudId,
            fecha_creacion: this.$moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss'),
            fecha_actualizacion: this.$moment(item.updatedAt).format(
              'DD/MM/YYYY HH:mm:ss',
            ),
          }))
          if (data) exportFromJSON({ data, fileName, exportType })
        } catch (error) {
          console.log('error', error)
        }
        this.close()
      })
    },
    truncatedCloudId(cloudId) {
      if (cloudId) {
        const maxLength = 8
        if (cloudId.length <= maxLength) {
          return cloudId
        }
        const truncatedText = cloudId.substring(0, maxLength)
        return `${truncatedText}...`
      }
      return ''
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.device-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>
